import { Tabs } from 'antd';
import React from 'react';

import BuyerRegistrationPayments from '../containers/BuyerRegistrationPayments';
import SellerRegistrationPayments from '../containers/SellerRegistrationPayments';
import SoldVehiclePayments from '../containers/SoldVehiclePayments';

const Report: React.FC = () => {
  return (
    <Tabs defaultActiveKey='1'>
      <Tabs.TabPane tab='Seller Commission Payment' key='1'>
        <SellerRegistrationPayments />
      </Tabs.TabPane>
      <Tabs.TabPane tab='Buyer Registration Payments' key='2'>
        <BuyerRegistrationPayments />
      </Tabs.TabPane>
      <Tabs.TabPane tab='Sold Vehicle Payments' key='4'>
        <SoldVehiclePayments />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default Report;
